import comScreenDP from './comScreenDP.vue'

export default comScreenDP
